export const environment = {
    version: 'v2.0.3.1',
    production: false,
    HTTP:'https://',
    APP_URL:'cloudbite-uat.qubeposcloud-uat.com',
    API_URL:'cloudbite-uat.qubeposcloud-uatapi.com',
    CLIENT_URL:'cloudbite-uat.qubeposcloud-uat.com',
    ROUTING_NAME :'cloudbite-uat',
    DOMAIN: 'qubeposcloud-uat',
    DEMO: 'UAT',
    STORE: {
        BUSSINESS_HOURS: false,
        ERECEIPT: false,
    }
};